import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { ItemVM } from 'shell/view-models/item';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';

export enum IDCancellationReason {
  Accertata = '1',
  Presunta = '2',
}

const list = Object.freeze([
  {
    id: IDCancellationReason.Accertata,
    value: 'Morte accertata',
  },
  {
    id: IDCancellationReason.Presunta,
    value: 'Morte presunta',
  },
]);

interface CancellationReasonProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>) => void;
  error?: boolean;
  label: string;
}

const CancellationReasonComponent = ({
  disabled,
  onChange,
  value,
  error,
  label,
}: CancellationReasonProps): React.ReactElement => {
  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id={`label-${label}`}>
        {label}
      </InputLabel>
      <PmiSelect
        labelId={`label-${label}`}
        id={`id-${label}`}
        name={`id-${label}`}
        value={value}
        label={label}
        onChange={onChange}
        disabled={disabled}
        error={error}
      >
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

CancellationReasonComponent.displayName = 'Cancellation reason component';

const CancellationReason = memo(CancellationReasonComponent);

export default CancellationReason as typeof CancellationReasonComponent;
